
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/elearning/the-complete-IELTS-training-program",
      function () {
        return require("private-next-pages/elearning/the-complete-IELTS-training-program.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/elearning/the-complete-IELTS-training-program"])
      });
    }
  